module.exports = __webpack_public_path__ + "build/img/hon_s.f133cb68.png";